import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
import { Button, Card, CardBody } from "reactstrap";

function ClientDashboardHero({ displayName, isApproved, showRequestStaff, t }) {
  const welcomeMessage = isApproved
    ? t("clientDashboardWelcomeApproved", {
        name: displayName,
        defaultValue: `Welcome ${displayName}, your company account has been approved.`,
      })
    : t("clientDashboardWelcome", {
        name: displayName,
        defaultValue: `Welcome ${displayName}.`,
      });

  return (
    <Card className="client-dashboard-hero border-0 mb-4">
      <CardBody className="p-4 p-lg-5 d-flex flex-column flex-lg-row align-items-lg-center justify-content-between gap-3">
        <div>
          <div className="client-dashboard-hero__eyebrow mb-2">
            {t("clientDashboardEyebrow", "Client portal")}
          </div>
          <h2 className="client-dashboard-hero__title mb-0">{welcomeMessage}</h2>
        </div>
        {showRequestStaff && (
          <Button
            tag={Link}
            to="/create-booking"
            color="primary"
            className="client-dashboard-hero__cta flex-shrink-0"
          >
            <i className="bx bx-user-plus me-1" />
            {t("clientMenuRequestStaff", "Request Staff")}
          </Button>
        )}
      </CardBody>
    </Card>
  );
}

ClientDashboardHero.propTypes = {
  displayName: PropTypes.string.isRequired,
  isApproved: PropTypes.bool.isRequired,
  showRequestStaff: PropTypes.bool,
  t: PropTypes.func,
};

ClientDashboardHero.defaultProps = {
  showRequestStaff: true,
};

export default withTranslation()(ClientDashboardHero);
